module.exports = __webpack_public_path__ + "img/unknownUser_w.b4755a51.svg";